// The `PayPalMessages` component integrates PayPal's "Pay Later" messaging into a React application.
// It dynamically loads the PayPal SDK and renders financing options based on the provided `price` and `currency`.
// The component ensures client-side execution using the `'use client'` directive and utilizes a `useRef` to render the
// PayPal message container. Styled with a simple text layout, it helps display installment or financing offers
//  on product pages.

'use client';

import React from 'react';
import { PayPalScriptProvider, PayPalMessages as SDKPayPalMessages } from '@paypal/react-paypal-js';

interface PayPalMessagesProps {
  price: number;
  currency: any;
}

const PayPalMessages: React.FC<PayPalMessagesProps> = ({ price, currency }) => {
  const clientId = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID as string;

  return (
    <PayPalScriptProvider
      options={{
        clientId,
        currency,
        components: 'messages',
      }}
    >
      <SDKPayPalMessages
        forceReRender={[price, currency]}
        amount={price}
        currency={currency}
        style={{
          layout: 'text',
          logo: {
            type: 'primary',
            position: 'top',
          },
          text: {
            size: 12,
          },
        }}
        // placement="product"
      />
    </PayPalScriptProvider>
  );
};

export default PayPalMessages;
